import { useQuery } from "@tanstack/react-query";
import { EmptyState, Notice, Seitenzustand } from "../ui";
import { Card, PageHeader } from "../ui/Layout";
import { api, rufe } from "../api/client";
import { formatDatumZeit } from "@shared/zeit";

interface Mail {
  id: string;
  an: string;
  betreff: string;
  text: string;
  erstelltAt: string;
}

export function Postfach() {
  const q = useQuery({ queryKey: ["admin", "postfach"], queryFn: () => rufe<{ transport: string; mails: Mail[] }>(api.api.admin.postfach.$get()), refetchInterval: 5000 });
  return (
    <>
      <PageHeader title="Dev-Postfach" sub="Ausgehende E-Mails, solange kein Versand über eine Domain eingerichtet ist" />
      <Notice tone="info" title="Nur bis zur Produktionsdomain">
        Links aus diesen Mails lassen sich direkt anklicken. Mit der Domain (Etappe 7) werden die Mails über den Cloudflare Email Service verschickt.
      </Notice>
      <Seitenzustand query={q} istLeer={(d) => d.mails.length === 0} leer={<EmptyState illustration="all-done" title="Noch keine E-Mails">Anmeldelinks und Einladungen erscheinen hier.</EmptyState>}>
        {(d) => (
          <div className="sc-col" style={{ gap: "var(--space-4)" }}>
            {d.mails.map((m) => (
              <Card key={m.id} title={m.betreff}>
                <div className="sc-muted sc-small">
                  An {m.an} · {formatDatumZeit(m.erstelltAt)}
                </div>
                <div className="app-mono-wrap">{verlinke(m.text)}</div>
              </Card>
            ))}
          </div>
        )}
      </Seitenzustand>
    </>
  );
}

function verlinke(text: string) {
  const teile = text.split(/(https?:\/\/\S+)/g);
  return teile.map((t, i) => (/^https?:\/\//.test(t) ? <a key={i} href={t}>{t}</a> : <span key={i}>{t}</span>));
}
